import { RootState } from '@reducers';

export const selectFeatureCompany = (state: RootState) => state.featureReducer.companyReducer;
